import React, { Component } from 'react';

import AllAbilities from '../components/Banners/AllAbilities';
import GlobalExpansion from '../components/Banners/GlobalExpansion';
import HeroTheWorkout from '../components/Banners/HeroTheWorkout';
import TheCoaching from '../components/Banners/TheCoaching';
import TheMovements from '../components/Banners/TheMovements';
import TheWorkoutInNumbers from '../components/Banners/TheWorkoutInNumbers';
import TheWorkoutLikeMagic from '../components/Banners/TheWorkoutLikeMagic';
import Layout from '../components/Layout';
import SEO from '../components/Seo';

class Page extends Component {
  render() {
    return (
      <Layout navInvert>
        <SEO pageTitle="Ritual HIIT" />
        <HeroTheWorkout />
        <GlobalExpansion />
        <TheWorkoutLikeMagic />
        <TheWorkoutInNumbers />
        <TheCoaching />
        <TheMovements />
        <AllAbilities />
      </Layout>
    );
  }
}

export default Page;
